import LegacyHandicapImport from '@/components/dialogs/LegacyHandicapImport.vue'
import { type ExportedContent, type LegacyHandicapAssignments, legacyHandicapGroups } from '@/network/legacyHandicaps'
import { useQuasar } from 'quasar'

export function useLegacyHandicapImport() {
    const quasar = useQuasar()

    return function resolveLegacyHandicaps(content: ExportedContent): Promise<LegacyHandicapAssignments | null> {
        const groups = legacyHandicapGroups(content)
        if (groups.length === 0)
            return Promise.resolve({})

        return new Promise(resolve => {
            quasar.dialog({
                component: LegacyHandicapImport,
                componentProps: { groups, races: content.event.races.map(race => race.race) },
            }).onOk((assignments: LegacyHandicapAssignments) => resolve(assignments))
                .onDismiss(() => resolve(null))
        })
    }
}
